import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MakeService } from './make-service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-make',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './make.html',
  styleUrls: ['./make.scss']
})
export class Make implements OnInit {
  searchText: string = '';
  makeList: any[] = [];
  loading: boolean = true;
  selectedMake: string | null = null;

  constructor(
    private makeService: MakeService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.clearLocalStorage();

    if (localStorage.getItem('selectedMake')) {
      this.selectedMake = localStorage.getItem('selectedMake');
    }

    this.getMakeList();
  }

  // Get Make List
  getMakeList() {
    const data = sessionStorage.getItem('spareVehicleDetails');

    if (data) {
      this.loading = false;
      const res = JSON.parse(data);
      this.processMakeResponse(res);
    } else {
      this.makeService.getMake().subscribe({
        next: (result: any) => {
          this.loading = false;
          sessionStorage.setItem('spareVehicleDetails', JSON.stringify(result));
          this.processMakeResponse(result);
        },
        error: (err: any) => {
          this.loading = false;
          console.error('Error fetching makes', err);
        }
      });
    }
  }

  // Process API data into makeList
  private processMakeResponse(res: any) {
    this.makeList = [];

    const process = (make: any) => {
      const originalTitle = make[0]['title'];
      const cleanedTitle = originalTitle.includes('-')
        ? originalTitle.split('-')[0].trim()
        : originalTitle;

      this.makeList.push({
        ...make[0],
        displayTitle: cleanedTitle // used in UI
      });
    };

    // Universal first
    Object.values(res.data).forEach((make: any) => {
      if (make[0]['title'] === 'Universal') {
        process(make);
      }
    });

    // then all others
    Object.values(res.data).forEach((make: any) => {
      if (make[0]['title'] !== 'Universal') {
        process(make);
      }
    });
  }

selectMake(make: any) {
  // store cleaned title
  const valueToStore = make.displayTitle;

  if (
    localStorage.getItem('selectedMake') &&
    localStorage.getItem('selectedModel') &&
    localStorage.getItem('selectedYear') &&
    localStorage.getItem('variant')
  ) {
    localStorage.setItem('newMake', valueToStore);
  } else {
    localStorage.setItem('selectedMake', valueToStore);
  }

  // store makeKey too
  localStorage.setItem('makeKey', make.key);

  // navigate to model page
  this.router.navigate(['/model']);
}



  selectUniversalVehicle() {
    localStorage.setItem('vehicleType', 'universal');
    this.router.navigate(['spare-parts-list']);
  }

  clearLocalStorage() {
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('variant');
  }

  clearSearch() {
    this.searchText = '';
  }

  // Filter logic
  get filteredMakes(): any[] {
    if (!this.searchText) return this.makeList;
    return this.makeList.filter((make) =>
      make.displayTitle.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  goToModel(make: any) {
    // Store makeKey in localStorage (so it can be used in Model page API call)
    localStorage.setItem('makeKey', make.key);

    // Navigate to Model page
    this.router.navigate(['/model']);
  }
}
